import { gql } from 'apollo-boost'

export type PaymentStatus =
  | 'pending'
  | 'authorized'
  | 'paid'
  | 'failed'
  | 'reverted'
  | 'canceled'
  | 'adjusted'
  | 'scheduled'
  | 'capture_pending'

export type PaymentOrderStatus = 'pending' | 'paid' | 'failed' | 'canceled'

export type TenderType = 'BRAINTREEINLINE2' | 'CASH' | 'LOYALTY'
export type Cents = number

export interface Payment {
  id: number
  status: PaymentStatus
  errorMessage: string | null
  type: AdjustmentType
  customerName: string
  tenderId: number
  tenderType: TenderType
  tenderLabel: string
  amount: Cents
  account_id: string | null
  details: null | {
    cardHolderName: string
    cardLastDigits: string
    cardType: string
  }
  note: string
  externalTransactionId: null | string
  executedAt: null | string
  parentPaymentId: null | number
}

export interface PaymentAdjustment {
  id: string
  type?: AdjustmentType
  parentPaymentId: number
  tip: number
  subtotal: number
  delivery: number
  notes: string
  limit: number
  mode?: AdjustmentType
}

export type AdjustmentType = 'charge' | 'adjustment' | 'refund' | 'chargeback' | 'authorized'

export interface PaymentOrder {
  id: number
  status: PaymentOrderStatus
  payments: Payment[]
}

export const GET_ORDER_PAYMENTS = gql`
  query order_payments($order_id: ID!) {
    order(id: $order_id) {
      id
      status
      payments {
        id
        type
        customerName
        tenderId
        tenderType
        tenderLabel
        note
        amount
        account_id

        details {
          cardHolderName
          cardLastDigits
          cardType
        }
        externalTransactionId
        executedAt
        parentPaymentId
        status
        errorMessage
      }
    }
  }
`
